import { DesignProp, LayoutProp } from "../PropCategories";

export const alignItems = {
  prop: "style-attribute",
  name: "Alignment",
  nameI18n: "builder_ui.prop_type.styles.item_alignment",
  category: [DesignProp, LayoutProp],
  type: "select",
  defaultValue: "center",
  options: [
    {
      label: "Top",
      labelI18n: "builder_ui.prop_type.styles.item_alignment_types.top",
      value: "flex-start",
    },
    {
      label: "Center",
      labelI18n: "builder_ui.prop_type.styles.item_alignment_types.center",
      value: "center",
    },
    {
      label: "Bottom",
      labelI18n: "builder_ui.prop_type.styles.item_alignment_types.bottom",
      value: "flex-end",
    },
    {
      label: "Stretch to fill",
      labelI18n: "builder_ui.prop_type.styles.item_alignment_types.stretch",
      value: "stretch",
    },
    {
      label: "Align to text",
      labelI18n: "builder_ui.prop_type.styles.item_alignment_types.baseline",
      value: "baseline",
    },
  ],
} as const;
